import { render, staticRenderFns } from "./UsersIcon.vue?vue&type=template&id=3cf579ca&scoped=true&"
import script from "./UsersIcon.vue?vue&type=script&lang=js&"
export * from "./UsersIcon.vue?vue&type=script&lang=js&"
import style0 from "./UsersIcon.vue?vue&type=style&index=0&id=3cf579ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf579ca",
  null
  
)

export default component.exports